import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_BEFORE_LEAVING_STATE,
  RESET_AFTER_LEAVING_STATE,
  RESET_SPECIAL_EVENT_STATE,
  RESET_PELEVANT_PERSON_STATE,
  RESET_TRAVEL_AGENT_STATE,
  RESET_SPECIAL_EVENT_AL_STATE,
  RESET_PELEVANT_PERSON_AL_STATE,
  RESET_CUTTING_YOU_TRIP_STATE,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_THE_RELEVANT_PERSON_STATE,
  RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE,
  RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT,
  RESET_TRAVEL_AGENT_CANCELLATION_FEE,
  RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    haveYouCanceledOrChangedYourJourneyBeforeLeaving: '',
    wereYouDelayedWhileTravelingToASpecialEvent: '',
    changesToYourJourneyBeforeLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: '',
    wereAnyOfYourTravelPlansOrganisedByATravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems2: [],
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: '',
    nameOfRelevantPerson: '',
    dateOfBirthOfRelevantPerson: '',
    relationshipWithRelevantPerson: '',
    changesToYourJourneyBeforeLeavingExpenseItems3: [],
    changesToYourJourneyBeforeLeavingExpenseItems4: [],
    wereYouChargedACancellationFeeByTheTravelAgent: '',
    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: '',
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],

    haveYouChangedYourJourneyAfterLeaving: '',
    wereYouDelayedWhileTravelingToASpecialEventAL: '',
    changesToYourJourneyAfterLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL: '',
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: '',
    nameOfRelevantPersonAL: '',
    dateOfBirthOfRelevantPersonAL: '',
    relationshipWithRelevantPersonAL: '',
    changesToYourJourneyAfterLeavingExpenseItems2: [],
    whatExpensesAreYouClaimingFor: [],
    cuttingYourTripShortToReturnHomeExpenseItems: [],
    travelInterruptionExpenseItems: [],
    resumingYourTripBackOverseasItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
  errors: [],
});

const initialBeforeLeaving = {
  form: {
    wereYouDelayedWhileTravelingToASpecialEvent: '',
    changesToYourJourneyBeforeLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: '',
    wereAnyOfYourTravelPlansOrganisedByATravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems2: [],
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: '',
    nameOfRelevantPerson: '',
    dateOfBirthOfRelevantPerson: '',
    relationshipWithRelevantPerson: '',
    changesToYourJourneyBeforeLeavingExpenseItems3: [],
    wereYouChargedACancellationFeeByTheTravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems4: [],
    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: '',
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialWereYouDelayedWhileTravelingToASpecialEvent = {
  form: {
    changesToYourJourneyBeforeLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: '',
    wereAnyOfYourTravelPlansOrganisedByATravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems2: [],
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: '',
    nameOfRelevantPerson: '',
    dateOfBirthOfRelevantPerson: '',
    relationshipWithRelevantPerson: '',
    changesToYourJourneyBeforeLeavingExpenseItems3: [],
    wereYouChargedACancellationFeeByTheTravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems4: [],
    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: '',
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialDidYouCancelOrChangeYourTravelPlansDueToARelevantPerson = {
  form: {
    wereAnyOfYourTravelPlansOrganisedByATravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems2: [],
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: '',
    nameOfRelevantPerson: '',
    dateOfBirthOfRelevantPerson: '',
    relationshipWithRelevantPerson: '',
    changesToYourJourneyBeforeLeavingExpenseItems3: [],
    wereYouChargedACancellationFeeByTheTravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems4: [],
    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: '',
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialTheRelevantPersonsExistingHealthCondition = {
  form: {
    changesToYourJourneyBeforeLeavingExpenseItems3: [],
    nameOfRelevantPerson: '',
    dateOfBirthOfRelevantPerson: '',
    relationshipWithRelevantPerson: '',
    wereAnyOfYourTravelPlansOrganisedByATravelAgentPI: '',
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialTheTravelAgent = {
  form: {
    wereYouChargedACancellationFeeByTheTravelAgent: '',
    changesToYourJourneyBeforeLeavingExpenseItems4: [],
  },
};

const initialWereAnyOfYourTravelPlansOrganisedByATravelAgentPI = {
  form: {
    wereYouChargedACancellationFeeByTheTravelAgentPI: '',
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialWereYouChargedACancellationFeeByTheTravelAgentPI = {
  form: {
    changesToYourJourneyBeforeLeavingExpenseItems4PI: [],
  },
};

const initialAfterLeaving = {
  form: {
    wereYouDelayedWhileTravelingToASpecialEventAL: '',
    changesToYourJourneyAfterLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL: '',
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: '',
    nameOfRelevantPersonAL: '',
    dateOfBirthOfRelevantPersonAL: '',
    relationshipWithRelevantPersonAL: '',
    changesToYourJourneyAfterLeavingExpenseItems2: [],
    whatExpensesAreYouClaimingFor: [],
    cuttingYourTripShortToReturnHomeExpenseItems: [],
    travelInterruptionExpenseItems: [],
    resumingYourTripBackOverseasItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
};

const initialWereYouDelayedWhileTravelingToASpecialEventAL = {
  form: {
    changesToYourJourneyAfterLeavingExpenseItems1: [],
    didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL: '',
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: '',
    nameOfRelevantPersonAL: '',
    dateOfBirthOfRelevantPersonAL: '',
    relationshipWithRelevantPersonAL: '',
    changesToYourJourneyAfterLeavingExpenseItems2: [],
    whatExpensesAreYouClaimingFor: [],
    cuttingYourTripShortToReturnHomeExpenseItems: [],
    travelInterruptionExpenseItems: [],
    resumingYourTripBackOverseasItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
};

const initialDidYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL = {
  form: {
    wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: '',
    nameOfRelevantPersonAL: '',
    dateOfBirthOfRelevantPersonAL: '',
    relationshipWithRelevantPersonAL: '',
    changesToYourJourneyAfterLeavingExpenseItems2: [],
    whatExpensesAreYouClaimingFor: [],
    cuttingYourTripShortToReturnHomeExpenseItems: [],
    travelInterruptionExpenseItems: [],
    resumingYourTripBackOverseasItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
};

const initialWasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL = {
  form: {
    nameOfRelevantPersonAL: '',
    dateOfBirthOfRelevantPersonAL: '',
    relationshipWithRelevantPersonAL: '',
    changesToYourJourneyAfterLeavingExpenseItems2: [],
    whatExpensesAreYouClaimingFor: [],
    cuttingYourTripShortToReturnHomeExpenseItems: [],
    travelInterruptionExpenseItems: [],
    resumingYourTripBackOverseasItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
};

const initialCuttingYourTripShortToReturnHome = {
  form: {
    cuttingYourTripShortToReturnHomeExpenseItems: [],
  },
};

const initialTravelInterruption = {
  form: {
    travelInterruptionExpenseItems: [],
    didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: [],
    petBoardingFacilityExpenseItems: [],
    childCareExpensesExpenseItems: [],
  },
};

const initialResumingYourTripBackOverseas = {
  form: {
    resumingYourTripBackOverseasItems: [],
  },
};

function changesToYourJourneySCTIStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_BEFORE_LEAVING_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems1'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems2'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialBeforeLeaving);
    case RESET_SPECIAL_EVENT_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems1'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems2'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialWereYouDelayedWhileTravelingToASpecialEvent);
    case RESET_PELEVANT_PERSON_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems2'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialDidYouCancelOrChangeYourTravelPlansDueToARelevantPerson);
    case RESET_TRAVEL_AGENT_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4'], [])
        .mergeDeep(initialTheTravelAgent);
    case RESET_AFTER_LEAVING_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems1'], [])
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2'], [])
        .setIn(['form', 'whatExpensesAreYouClaimingFor'], [])
        .setIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems'], [])
        .setIn(['form', 'travelInterruptionExpenseItems'], [])
        .setIn(['form', 'resumingYourTripBackOverseasItems'], [])
        .setIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption'], [])
        .setIn(['form', 'petBoardingFacilityExpenseItems'], [])
        .setIn(['form', 'childCareExpensesExpenseItems'], [])
        .mergeDeep(initialAfterLeaving);
    case RESET_SPECIAL_EVENT_AL_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems1'], [])
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2'], [])
        .setIn(['form', 'whatExpensesAreYouClaimingFor'], [])
        .setIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems'], [])
        .setIn(['form', 'travelInterruptionExpenseItems'], [])
        .setIn(['form', 'resumingYourTripBackOverseasItems'], [])
        .setIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption'], [])
        .setIn(['form', 'petBoardingFacilityExpenseItems'], [])
        .setIn(['form', 'childCareExpensesExpenseItems'], [])
        .mergeDeep(initialWereYouDelayedWhileTravelingToASpecialEventAL);
    case RESET_PELEVANT_PERSON_AL_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2'], [])
        .setIn(['form', 'whatExpensesAreYouClaimingFor'], [])
        .setIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems'], [])
        .setIn(['form', 'travelInterruptionExpenseItems'], [])
        .setIn(['form', 'resumingYourTripBackOverseasItems'], [])
        .setIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption'], [])
        .setIn(['form', 'petBoardingFacilityExpenseItems'], [])
        .setIn(['form', 'childCareExpensesExpenseItems'], [])
        .mergeDeep(initialDidYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL);
    case RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyAfterLeavingExpenseItems2'], [])
        .setIn(['form', 'whatExpensesAreYouClaimingFor'], [])
        .setIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems'], [])
        .setIn(['form', 'travelInterruptionExpenseItems'], [])
        .setIn(['form', 'resumingYourTripBackOverseasItems'], [])
        .setIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption'], [])
        .setIn(['form', 'petBoardingFacilityExpenseItems'], [])
        .setIn(['form', 'childCareExpensesExpenseItems'], [])
        .mergeDeep(initialWasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL);
    case RESET_CUTTING_YOU_TRIP_STATE:
      return state
        .setIn(['form', 'cuttingYourTripShortToReturnHomeExpenseItems'], [])
        .mergeDeep(initialCuttingYourTripShortToReturnHome);

    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
        .setIn(['form', 'travelInterruptionExpenseItems'], [])
        .setIn(['form', 'didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption'], [])
        .setIn(['form', 'petBoardingFacilityExpenseItems'], [])
        .setIn(['form', 'childCareExpensesExpenseItems'], [])
        .mergeDeep(initialTravelInterruption);
    case RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE:
      return state
        .setIn(['form', 'resumingYourTripBackOverseasItems'], [])
        .mergeDeep(initialResumingYourTripBackOverseas);
    case RESET_THE_RELEVANT_PERSON_STATE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems3'], [])
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialTheRelevantPersonsExistingHealthCondition);
    case RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialWereAnyOfYourTravelPlansOrganisedByATravelAgentPI);
    case RESET_TRAVEL_AGENT_CANCELLATION_FEE:
      return state
        .setIn(['form', 'changesToYourJourneyBeforeLeavingExpenseItems4PI'], [])
        .mergeDeep(initialWereYouChargedACancellationFeeByTheTravelAgentPI);
    default:
      return state;
  }
}

export default changesToYourJourneySCTIStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/reducer.js